export default __webpack_public_path__ + "static/media/1-4-3.03e8378e.jpg";